export const tr = {
    placeholder: 'Negatif anahtar sözcük grubu girin'
};
